/* eslint-disable default-param-last */
/* eslint-disable no-console */
import { GlobalState } from '@leverege/ui-redux';
export default class ItemDelegate {
  /**
   * OPTIONAL
   * returns group delegate for the group this item is in (if it exists)
   * Not all interfaces will support a parent group concept
   * @returns {GroupDelegate} group delegate for the group this item is in
   */
  getGroup() {
    console.warn('unimplemented: ItemDelegate.getGroup');
  }

  /**
   * Returns the parent's action object. This function is optional and
   * only needs to be implemented if the given item can have a parent item.
   * Not all items are hierarchical in this way
   */
  parent() {
    console.warn('unimplemented: ItemDelegate.parent');
  }

  /**
   * OPTIONAL
   * Returns a action object for the child attribute. If the attribute
   * is a group relationship, a GroupDelegate object is returned. If it
   * is a one to one relationship, an ItemDelegate will be returned. If
   * it is not a relationship, null is returned.
   * @returns {GroupDelegate|ItemDelegate} the delegate instance
   */
  child(attrPath) {
    console.warn('unimplemented: ItemDelegate.child');
  }

  /**
   * Returns the interface url for this item action object
   */
  getInterfaceUrl() {
    console.warn('unimplemented: ItemDelegate.getInterfaceUrl');
  }

  /**
   * Returns the url for this item action object
   */
  getUrl() {
    console.warn('unimplemented: ItemDelegate.getUrl');
  }

  /**
   * Returns a redux action or thunk function that will call api to read a child of the current path
   * @param {object} data values of the item to be changed
   * @param {object} options api options
   * @returns {function|Object} redux action or thunk function
   */
  get(options) {
    console.warn('unimplemented: ItemDelegate.get');
  }

  /**
   * OPTIONAL
   * Returns a redux action or thunk function that will ask the api if you can read the item at the current path
   * @param {object} query  query object to send to the api
   * @returns {function|Object} redux action or thunk function
   */
  requestCanGet(query) {
    console.warn('unimplemented: ItemDelegate.requestCanGet');
  }

  /**
   * OPTIONAL
   * Returns a redux action or thunk function that will call the api to create an item at the current path
   * @param {object} data the data of the item to create
   * @param {object} options a set of options
   * @returns {function|Object} redux action or thunk function
   */
  create(data, options) {
    console.warn('unimplemented: ItemDelegate.create');
  }

  /**
   * OPTIONAL
   * Returns a redux action or thunk function that will ask the api if you can create an item at the current path
   * @param {object} query  query object to send to the api
   * @param {object} body the data of the object to create
   * @returns {function|Object} redux action or thunk function
   */
  requestCanCreate(query, body) {
    console.warn('unimplemented: ItemDelegate.requestCanCreate');
  }

  /**
   * OPTIONAL
   * Returns a redux action or thunk function that will call api to update a child of the current path
   * @param {object} data values of the item to be changed
   * @param {object} options api options
   * @returns {function|Object} redux action or thunk function
   */
  update(data, options) {
    console.warn('unimplemented: ItemDelegate.update');
  }

  /**
   * OPTIONAL
   * Returns a redux action or thunk function that will ask the api if you can update the item at the current path
   * @param {object} query  query object to send to the api
   * @param {object} body the data of the update
   * @returns {function|Object} redux action or thunk function
   */
  requestCanUpdate(query, body) {
    console.warn('unimplemented: ItemDelegate.requestCanUpdate');
  }

  /**
   * OPTIONAL
   * Returns a redux action that will call api to delete a child of the current path
   * @param {object} options api options
   * @returns {function|Object} redux action or thunk function
   */
  delete(body, options, reducerOptions) {
    console.warn('unimplemented: ItemDelegate.delete');
  }

  /**
   * OPTIONAL
   * Returns a redux action that will request if you can delete the item at the current path
   * @param {object} query  query object to send to the api
   * @param {object} body body of the request to test
   * @param {string} body.deleteDevice optional, if set to 'force' will delete
   *                                   the device and not just the relationship to it at a deep path
   * @returns {function|Object} redux action or thunk function
   */
  requestCanDelete(query, body) {
    console.warn('unimplemented: ItemDelegate.requestCanDelete');
  }

  /**
   * OPTIONAL
   * Returns a redux action that makes an request to get the history of an object at the path
   * @param {object} query.query query params that the server will use 
   * @param {string} query.queryName query identifier 
   * @param {object} options api options
   * @returns {function|Object} redux action or thunk function
   * @deprecated
   */
  history(query, options) {
    console.warn('unimplemented: ItemDelegate.history');
  }

  /**
   * Returns a redux action that will ask the api if you can get history at the current path
   * @param {object} query  query object to send to the api
   * @returns {function|Object} redux action or thunk function
   * @deprecated
   */
  requestCanHistory(query) {
    console.warn('unimplemented: ItemDelegate.requestCanHistory');
  }

  /**
   * Returns a Users object, used to access users with permissions on this item
   * @returns {Object} the users object
   */
  users() {
    console.warn('unimplemented: ItemDelegate.users');
  }

  /**
   * Returns a User object, used to access a user with permissions on this item
   * @param {string} userId the id of the user
   * @returns 
   */
  user(userId) {
    console.warn('unimplemented: ItemDelegate.user');
  }

  /**
   * OPTIONAL
   * Returns a redux action to go to the child attrPath's url.
   * This only need be implemented by Items that can have child groups
   * @param {*} attrPath 
   * @returns {Object} a redux action
   */
  goTo(attrPath) {
    // NOTE: you should add a check for attrPath validity
    if (this.isGotoAllowed()) {
      console.warn('unimplemented: ItemDelegate.goTo');
    }
    return {
      type: 'noop'
    };
  }

  // local access

  /**
   * Get the status of any current api calls to this group (typically for get calls)
   * @param {Object} state the redux state (or other local state) to get api status from
   * @returns {*} returns the status of the items api calls
   */
  getStatus(state = GlobalState.get()) {
    console.warn('unimplemented: ItemAction.getStatus');
  }

  /**
   * Get the local item as retrieved from the api
   * @param {Object} state the redux state (or other local state) to get the item from
   * @returns {*} returns the item received from the api
   */
  getItem(state = GlobalState.get()) {
    console.warn('unimplemented: ItemDelegate.getItem');
  }

  /**
   * OPTIONAL
   * Get the item's history as retrieved from the api
   * @param {Object} state the redux state (or other local state) to get history from
   * @param {Object} options any options to specify how to get the history
   * @returns {*} returns the history received from the api
   * @deprecated
   */
  getHistory(state = GlobalState.get(), queryName) {
    console.warn('unimplemented: ItemDelegate.getHistory');
  }

  /**
   * Get whether or not the delegate are waiting on any api requests
   * @param {Object} state the redux state (or other local state) to get api status from
   * @returns {*} returns whether or not this is loading
   */
  isLoading(state = GlobalState.get()) {
    console.warn('unimplemented: ItemDelegate.isLoading');
  }

  /**
   * Basically the opposite of isLoading, check whether or not all
   * api requests are complete (regardless of failure)
   * @param {Object} state the redux state (or other local state) to get api status from
   * @returns {*} returns whether or not this is loading
   */
  isDone(state = GlobalState.get()) {
    console.warn('unimplemented: ItemDelegate.isDone');
  }

  // accessors

  /**
   * OPTIONAL
   * Accesses whether or not a user can create an item at this path in the api from state
   * @param {object} state redux state
   * @param {boolean} requestIfUnavailable whether or not we should initiate requesting the can value if we don't have it
   * @returns {boolean} whether or not we can create
   */
  canCreate(state = GlobalState.get(), requestIfUnavailable = true) {
    console.warn('unimplemented: ItemDelegate.canCreate');
  }

  /**
   * OPTIONAL
   * Accesses whether or not a user can get an item at this path in the api from state
   * @param {object} state redux state
   * @param {boolean} requestIfUnavailable whether or not we should initiate requesting the can value if we don't have it
   * @returns {boolean} whether or not we can get
   */
  canGet(state = GlobalState.get(), requestIfUnavailable = true) {
    console.warn('unimplemented: ItemDelegate.canGet');
  }

  /**
   * OPTIONAL
   * Accesses whether or not a user can update an item at this path in the api from state
   * @param {object} state redux state
   * @param {boolean} requestIfUnavailable whether or not we should initiate requesting the can value if we don't have it
   * @returns {boolean} whether or not we can update
   */
  canUpdate(state = GlobalState.get(), requestIfUnavailable = true) {
    console.warn('unimplemented: ItemDelegate.canUpdate');
  }

  /**
   * OPTIONAL
   * Accesses whether or not a user can delete an item at this path in the api from state
   * @param {object} query the query of the delete request
   * @param {object} body the body of the delete request
   * @param {object} state redux state
   * @param {boolean} requestIfUnavailable whether or not we should initiate requesting the can value if we don't have it
   * @returns {boolean} whether or not we can delete the item
   */
  canDelete(query, body, state = GlobalState.get(), requestIfUnavailable = true) {
    console.warn('unimplemented: ItemDelegate.canDelete');
  }

  /**
   * OPTIONAL
   * Quickly checks the redux state for the Item's data
   * @param {string} id the id of the item
   * @param {object} state redux state
   * @return {object} the item
   */
  static getItem(id, state = GlobalState.get()) {
    console.warn('unimplemented: ItemDelegate.getItem (static)');
  }
}